import styled, { css } from 'styled-components';
import { StyledHeader } from './Header/Header.style';
import { getColor } from 'common/constants/_colors';

const WhiteSectionCSS = css`
  box-sizing: border-box;
  background: ${getColor('white')};
  padding: 2rem;
  border-radius: 5px;
  border: 1px solid ${getColor('catskillWhite')};
`;

export const StyledMetricsInspection = styled.div`
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  background: ${getColor('catskillGray')};

  & ${StyledHeader} {
    width: 100%;
    height: 8.1rem;
    margin-bottom: 1rem;
    ${WhiteSectionCSS};
    padding: 1.5rem;
    border-radius: 0px;
  }
`;

export const StyledChartsRow = styled.div`
  width: calc(100% - 2rem);
  height: 30%;
  display: flex;
  justify-content: space-between;
  margin: 1rem;
  margin-top: 0rem;
  gap: 1rem;
`;

const StyledChart = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  ${WhiteSectionCSS};
  padding: 0;
  overflow: hidden;
`;

export const StyledMetricChartWrapper = styled(StyledChart)`
  width: 40%;
`;
export const StyledScatterChartWrapper = styled(StyledChart)`
  width: 60%;
`;

export const StyledTableContainer = styled.div`
  margin: 1rem;
  margin-top: 0rem;
  width: calc(100% - 2rem);
  height: calc(70% - 11.1rem);
  overflow-y: auto;

  ${WhiteSectionCSS};
  padding-top: 0rem;
`;
